<template>
  <table id="GridViewRacing" class="accountTable" cellspacing="0" cellpadding="0" style="border-collapse:collapse;">
    <tr class="tableHead">
      <th scope="col" style="width:15%;">
          <div title="No."> {{ $t('no.') }}</div>
      </th>
      <th align="left" scope="col" style="width:14%;">
          <div title="Ngày">Ngày</div>
      </th>
      <th scope="col" style="width:26%;">
          <div title="Kết&nbsp;quả">Kết&nbsp;quả</div>
      </th>
      <th scope="col" style="width:10%;">
          <div title="Lẻ/Chẵn">L/C</div>
      </th>
      <th scope="col" style="width:10%;">
          <div title="Đầu&nbsp;tiên&nbsp;Đỏ/Trắng">Đầu&nbsp;tiên</div>
      </th>
      <th scope="col" style="width:10%;">
          <div title="Thứ&nbsp;hai&nbsp;Đỏ/Trắng">Thứ&nbsp;hai</div>
      </th>
      <th scope="col" style="width:10%;">
          <div title="Thứ&nbsp;ba&nbsp;Đỏ/Trắng">Thứ&nbsp;ba</div>
      </th>
      <th scope="col" style="width:10%;">
          <div title="Cuối&nbsp;cùng&nbsp;Đỏ/Trắng">Cuối&nbsp;cùng</div>
      </th>
    </tr>
    <tr
      v-for="(column, index) in content"
      :key="index"
      class="tableRow"
      valign="middle"
    >
      <td align="center" style="width:15%;">
        {{ column.id }}
      </td>
      <td style="width:14%;">
        {{ column.endAt }}
      </td>
      <td align="center" style="width:26%;">
        <span :class="setClass(column, 0)"></span>
        <span :class="setClass(column, 1)"></span>
        <span :class="setClass(column, 2)"></span>
        <span :class="setClass(column, 3)"></span>
      </td>
      <td class="hasTableGroup points-flexible" style="width:10%;">
        <div>
          <span :class="getOddColor(column)">{{getOdd(column)}}</span>
        </div>
      </td>
      <td class="hasTableGroup points-flexible" style="width:10%;">
        <div>
          <span :class="getColor(column, 0)">{{getValue(column, 0)}}</span>
        </div>
      </td>
      <td class="hasTableGroup points-flexible" style="width:10%;">
        <div>
          <span :class="getColor(column, 1)">{{getValue(column, 1)}}</span>
        </div>
      </td>
      <td class="hasTableGroup points-flexible" style="width:10%;">
        <div>
          <span :class="getColor(column, 2)">{{getValue(column, 2)}}</span>
        </div>
      </td>
      <td class="hasTableGroup points-flexible" style="width:10%;">
        <div>
          <span :class="getColor(column, 3)">{{getValue(column, 3)}}</span>
        </div>
      </td>
    </tr>
    <tr>
      <td colspan="8">
        <div class="pagination">
          <a @click="$emit('first-Page')">«</a>
          <a @click="$emit('previous-Page')">‹</a>
          <input type="text" :value="page" readonly="readonly" />
          <a @click="$emit('next-Page')">›</a>
          <a @click="$emit('last-Page')">»</a>
        </div>
      </td>
    </tr>
  </table>
</template>

<script>

export default {
  components: {

  },
  props: {
    page: String,
    content: Array,
  },
  methods: {
    getOdd: function(column) {
      // console.log('value', value)
      if(column.betTypeResult === null || column.betTypeResult === undefined){
        return "";
      }
      const value = column.betTypeResult.split(',')[0];
      return value === "ODD" ? "L" : "C";
    },
    getValue: function(column, pos) {
      // console.log('value', value)
      if(column.resultRaw === null || column.resultRaw === undefined){
        return "";
      }
      const value = column.resultRaw.split(',')[pos];
      return +value === 2 ? "Đ" : "T";
    },
    getColor: function(column, pos) {
      // console.log('value', value)
      if(column.resultRaw === null || column.resultRaw === undefined){
        return "";
      }
      const value = column.resultRaw.split(',')[pos];
      return +value === 2 ? "color-red" : "";
    },
    getOddColor: function(column, pos) {
      if(column.betTypeResult === null || column.betTypeResult === undefined){
        return "";
      }
      const value = column.betTypeResult.split(',')[0];
      return +value === "ODD" ? "color-red" : "color-blue";
    },
    setClass: function(column, pos) {
      if(column.resultRaw === null || column.resultRaw === undefined){
        return "";
      }
      const value = column.resultRaw.split(',')[pos];
      return +value === 2 ? "sedie-red" : "sedie-white";
    },
  }
}
</script>

<style>


</style>
